export default "__VITE_ASSET__gecknRm9__"